/**
 * Resolve API base URL for CRA.
 * When the UI is opened via a LAN IP (Windows → Ubuntu), rewrite localhost
 * env values to that same host so the browser does not hit Windows :3001.
 */
export function resolveApiBaseUrl(): string {
  const configured = (process.env.REACT_APP_API_URL ?? '').trim();
  const fallback = 'http://localhost:3001';
  const raw = configured !== '' ? configured : fallback;

  if (typeof window === 'undefined') {
    return raw.replace(/\/$/, '');
  }

  const pageHost = window.location.hostname;
  const isPageLocal = pageHost === 'localhost' || pageHost === '127.0.0.1';
  const pointsAtLocal = raw.includes('://localhost') || raw.includes('://127.0.0.1');

  if (!isPageLocal && pointsAtLocal) {
    const portMatch = raw.match(/:(\d+)\/?$/);
    const port = portMatch?.[1] ?? '3001';
    return `http://${pageHost}:${port}`;
  }

  return raw.replace(/\/$/, '');
}
